// The currency assumed wherever a record carries none (and the one the app is built around).
export const DEFAULT_CURRENCY_CODE = 'EUR';

export const AMOUNT_TYPE = { MIN: 'min', MAX: 'max' };

// NOTE: glyphs are intentionally inverted vs. their math meaning (H1MVP-4422).
// MIN = "at least this much / more than" is shown as ≤; MAX = "at most / less than" is shown as ≥.
export const amountTypeOptions = [
  { key: AMOUNT_TYPE.MIN, label: '≤', tagLabel: '≥' },
  { key: AMOUNT_TYPE.MAX, label: '≥', tagLabel: '≤' },
];
